import React, { Component } from 'react'
import styles from './style.module.less'
import { observer, inject } from 'mobx-react'
import classNames from 'classnames'
import { notify_type } from '../config'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { selectTab, unreadObj, changeSelectTab } = this.props.store

    let getUnreadEl = notice_type => {
      let num
      let isShow
      if (unreadObj[notice_type]) {
        num = Number(unreadObj[notice_type])
        isShow = Number(unreadObj[notice_type]) > 0
        return isShow ? (
          <span className={styles.noticeNum}>{num > 99 ? '99+' : num}</span>
        ) : null
      } else {
        return null
      }
    }

    return (
      <ul className={styles.menuWrap}>
        {notify_type
          .filter(item => !item.hidden)
          .map(({ id, name, iconId }) => {
            return (
              <li key={id} onClick={changeSelectTab(id)}>
                <p className={styles.subMenu}>
                  <span
                    className={classNames(styles.title, {
                      [styles[`title_${iconId}`]]: selectTab != id,
                      [styles[`title_${iconId}_select`]]: selectTab == id
                    })}
                  >
                    {name}
                  </span>
                  {getUnreadEl(id)}
                </p>
              </li>
            )
          })}
      </ul>
    )
  }
}
